export const DEFAULT_AUTH_NEXT_PATH = '/ask';

export type AuthLogoutResponse = {
  ok: true;
  redirectTo: string;
  providerLogoutUrl: string | null;
  freshAuth: boolean;
  nextPath: string;
};

export function sanitizeAuthNextPath(nextValue: string | null | undefined): string {
  const candidate = String(nextValue ?? '').trim();
  if (!candidate) return DEFAULT_AUTH_NEXT_PATH;
  if (!candidate.startsWith('/')) return DEFAULT_AUTH_NEXT_PATH;
  if (candidate.startsWith('//')) return DEFAULT_AUTH_NEXT_PATH;
  if (candidate.includes('\\')) return DEFAULT_AUTH_NEXT_PATH;
  if (candidate.includes('\r') || candidate.includes('\n')) return DEFAULT_AUTH_NEXT_PATH;
  return candidate;
}

export function buildLoginRedirectPath(
  nextValue: string | null | undefined,
  options?: {
    signedOut?: boolean;
    freshAuth?: boolean;
  },
): string {
  const params = new URLSearchParams();
  params.set('next', sanitizeAuthNextPath(nextValue));

  if (options?.signedOut) {
    params.set('signed_out', '1');
  }
  if (options?.freshAuth) {
    params.set('fresh', '1');
  }

  return `/login?${params.toString()}`;
}
